<div class="emd-container collapse-container">
    <div class="emd-container__header eu-justify_space-between collapse-header">
        <h2 class="emd-text _size_default _color_subtle">{{ title }}</h2>
        <button class="emd-btn _type_text" (click)="handleCollapse()">
            <i *ngIf="!isOpen" class="fa fa-chevron-down" aria-hidden="true"></i>
            <i *ngIf="isOpen" class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
    </div>
    <div *ngIf="isOpen" class="emd-container__content">
        <ng-content></ng-content>
    </div>
</div>
